<template>
	<div class="track-list">
		<div class="container">
			<h1 v-if="header">{{ this.header }}</h1>

			<ul class="tracks">
				<li v-for="(track, index) in tracks" v-if="(skipfirst == true && index != 0) || skipfirst == false" :class="{ extended: track.plays > 0 }" :key="index">
					<a :href="`https://last.fm/music/${track.artist}/_/${track.track}`" target="_blank">
						<div class="artwork">
							<img :src="track.artwork | secure" :alt="track.track">
						</div>
						<div class="track-time">
							<span>{{ getTimestamp(track.timestamp, longdate) }}</span>
						</div>
						<div v-if="track.plays" class="track-plays">
							<span>{{ track.plays + ` play` + (track.plays == 1 ? `` : `s`) }}</span>
						</div>
						<div class="track-info">
							<h1>{{ track.artist }}</h1>
							<h2>{{ track.track }}</h2>
						</div>
					</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'tracklist',
		
		data () {
			return {
			}
		},

		props: {
			header: String,
			tracks: Array,
			skipfirst: {
				default: false,
				type: Boolean
			},
			longdate: Boolean
		},

		filters: {
			secure (val) {
				if (val === null) return "//placehold.it/300x300?text=MR";
				return val.replace("http:", "https:");
			}
		},

		methods: {
			getTimestamp (timestamp, longDate) {
				var dateObj = new Date(timestamp * 1000);

				if (longDate !== true)
					return this.pad(dateObj.getHours()) + `:` + this.pad(dateObj.getMinutes()) + `:` + this.pad(dateObj.getSeconds());

				return this.pad(dateObj.getDate()) + `/` +  this.pad(dateObj.getMonth() + 1) + `/` + this.pad(dateObj.getFullYear()) + ` ` + this.pad(dateObj.getHours()) + `:` + this.pad(dateObj.getMinutes()) + `:` + this.pad(dateObj.getSeconds());
			},

			pad (number) {
				if (number < 10)
					return "0" + number;

				return number;
			}
		}
	}
</script>

<style lang="scss" scoped>
	$artwork-size: 150px;

	.track-list {
		align-items: center;
		border-bottom: 1px solid $default-border-col;
		clear: both;
		display: flex;
		float: left;
		justify-content: center;
		padding: 20px 0;
		width: 100%;

		h1 {
			font-size: 1.5rem;
			font-weight: bold;
		}

		@include mobile {
			h1 {
				text-align: center;
			}
		}

		.tracks {
			clear: both;
			display: flex;
			float: left;
			flex-wrap: wrap;
			justify-content: center;
			list-style: none;
			margin-top: 30px;
			text-align: center;
			width: 100%;

			li {
				clear: none;
				display: inline-block;
				float: none;
				margin-bottom: 20px;
				margin-right: 20px;
				width: calc(#{$artwork-size} + 40px);

				&:hover {
					background: darken(#FFF, 10%);
				}

				&:last-child {
					margin-right: 0;
				}

				a {
					clear: both;
					display: inline-block;
					float: left;
					height: 100%;
					padding: 20px;
					width: 100%;
				}
			}

			h1 {
				font-size: initial;
			}
		}

		.artwork {
			clear: both;
			display: inline-block;
			float: left;
			margin-bottom: 10px;
			width: 100%;

			img {
				border: 1px solid $default-border-col;
				border-radius: 50%;
				display: inline-block;
				float: left;
				height: $artwork-size;
				width: $artwork-size;
			}
		}

		.track-time,
		.track-plays {
			clear: both;
			display: inline-block;
			float: left;
			font-size: .8rem;
			margin-bottom: 5px;
			text-align: center;
			width: 100%;
		}		

		.track-info {
			clear: both;
			display: inline-block;
			float: left;
			text-align: center;
			width: 100%;
		}
	}

	body.is-dark {
		.track-list {
			border-color: $dark-border-color;

			.tracks {
				li:hover {
					background: lighten($dark-background, 10%);
				}
			}

			.artwork img {
				border-color: $dark-border-color;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// TrackList.vue?40dadbb7